import { render } from "./Index.vue?vue&type=template&id=4223113d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=4223113d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4223113d"

export default script